class AnnouncementBar extends HTMLElement {
    constructor() {
        super()
        this.hidden = false
        this.announcementData = document.getElementById(this.id).dataset
        this.getCookie(`${this.id}_dismissed`) && this.announcementData.cookies != 'true' ? this.hidden = true : this.hidden = false
        this.checkArrows()

        this.querySelector(".close")?.addEventListener("keypress", (e) => {
            e.preventDefault();

            if (e.key === "Enter") {
                this.closeAnnouncement();
            }
        })

    }

    isDismissed(announcementId) {
        return getCookie(`announcement_${announcementId}_dismissed`)
    }

    closeAnnouncement() {
        this.announcementsContainer = document.getElementById('announcement')
        const index = +this.announcementsContainer.dataset.index
        let arrowIndex = index + 1

        this.hidden = true
        if (this.announcementData.cookies != 'true') {
            this.setCookie(`${this.id}_dismissed`, true, +this.announcementData.expiry)
        }
        if (this.announcementsContainer.dataset.type == "inline" && index > 1) {
            arrowIndex = index - 1
            this.navigate('left')
        }
        this.checkArrows(`announcement_${arrowIndex}`)
    }

    checkArrows(index = null) {
        this.length = +document.getElementById(this.id).dataset.length - this.getDismissedCookies()
        if (this.length == 1) {
            document.getElementById(`btn_right_${index || this.id}`)?.remove()
            document.getElementById(`btn_left_${index || this.id}`)?.remove()
        }
    }

    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie(name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match && match[2] === "true") {
            return true
        }
        else {
            return false
        }
    }

    getDismissedCookies() {
        const match = document.cookie.match(/announcement_/g);
        return match?.length || 0
    }

    navigate(dir) {
        this.announcementsContainer = document.getElementById('announcement')
        this.length = +document.getElementById(this.id).dataset.length - this.getDismissedCookies()
        const index = +this.announcementsContainer.dataset.index
        let value = +this.announcementsContainer.style?.transform?.replace?.('translateX(', '').replace?.('%)', '') || 0

        this.announcementsContainer.style.opacity = 0

        if (dir === "right") {
            if (index === this.length) {
                this.announcementsContainer.dataset.index = 1
                value = 100
            } else {
                this.announcementsContainer.dataset.index = index + 1
            }

            this.announcementsContainer.style.transform = `translateX(${value - 100}%)`
        } else {
            if (index === 1) {
                this.announcementsContainer.dataset.index = this.length
                value = -((this.length) * 100)
            } else {
                this.announcementsContainer.dataset.index = index - 1
            }

            this.announcementsContainer.style.transform = `translateX(${value + 100}%)`
        }

        this.announcementsContainer.classList.remove('inline_navigate')
        setTimeout(() => {
            this.announcementsContainer.style.opacity = 1
            this.announcementsContainer.classList.add('inline_navigate')
        }, 0);
    }
}
// AUTO ROTATE ANNOUNCEMENT BAR
window.addEventListener('load', () => {
  setInterval(() => {
    const active = document.querySelector('announcement-bar');
    if (active && document.getElementById('announcement')?.dataset.type === 'inline') {
      active.navigate('right');
    }
  }, 2500);
});
customElements.define('announcement-bar', AnnouncementBar);